<template>
  <v-form v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field dense v-model="company" label="Công Ty" outlined required></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field dense outlined v-model="companyRole" label="Cấp bậc" required></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { get } from 'lodash'

export default {
  props: {
    teacher: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    valid: true,
    company: '',
    companyRole: ''
  }),
  created() {
    this.reset()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      if (this.teacher) {
        this.company = get(this.teacher, 'metadata.company', '')
        this.companyRole = get(this.teacher, 'metadata.companyRole', '')
      } else {
        this.company = ''
        this.companyRole = ''
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      return {
        company: this.company,
        companyRole: this.companyRole
      }
    }
  },
  watch: {
    teacher(teacher) {
      this.reset()
    }
  }
}
</script>

<style scoped></style>
